import { render } from "./CollectionGateOpening.vue?vue&type=template&id=dbd3ba34&scoped=true"
import script from "./CollectionGateOpening.vue?vue&type=script&lang=js"
export * from "./CollectionGateOpening.vue?vue&type=script&lang=js"

import "./CollectionGateOpening.vue?vue&type=style&index=0&id=dbd3ba34&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbd3ba34"]])

export default __exports__